// extracted by mini-css-extract-plugin
export default {"ForgotPasswordPage":"ForgotPasswordPage_ForgotPasswordPage__AwEiX"};